module.exports = __webpack_public_path__ + "static/img/1.59a71fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/3/1.png
// module id = abgO
// module chunks = 0